"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.languageData = void 0;
exports.getLanguageFlag = getLanguageFlag;
exports.getLanguageByCode = getLanguageByCode;
// FLAGS http://flag-icon-css.lip.is/
exports.languageData = [
    {
        code: 'en',
        name: 'English'
    },
    {
        code: 'fi',
        name: 'Suomi'
    },
    {
        code: 'ru',
        name: 'Русский'
    },
    {
        code: 'sv',
        name: 'Svenska'
    },
    {
        code: 'de',
        name: 'Deutsch'
    },
    {
        code: 'dk',
        name: 'Dansk'
    },
    {
        code: 'ee',
        name: 'Eesti'
    },
    {
        code: 'cz',
        name: 'Česká'
    },
    {
        code: 'sk',
        name: 'Slovensko'
    },
    {
        code: 'fr',
        name: 'France'
    },
    {
        code: 'es',
        name: 'España'
    },
    {
        code: 'no',
        name: 'Norway'
    },
    {
        code: 'lt',
        name: 'Lithuania'
    },
    {
        code: 'lv',
        name: 'Latvija'
    },
    {
        code: 'pl',
        name: 'Polska'
    }
];
function getLanguageFlag(lang) {
    return "/assets/flags/".concat(lang, ".svg");
}
function getLanguageByCode(code) {
    var language = exports.languageData.find(function (language) { return language.code === code; });
    return language !== null && language !== void 0 ? language : exports.languageData[0];
}
